<div
  class="palantir-tag"
  [class.minified]="minified"
  [class.palantir-tag--activatable]="activatable"
  [class.badge]="badge"
  [ngClass]="['palantir-tag__size--' + size, 'palantir-tag__style--' + style, 'palantir-tag__shape--' + shape]"
>
  <span>
    <ng-content></ng-content>
  </span>
</div>
